import { render, staticRenderFns } from "./ResponsePositionEditor.vue?vue&type=template&id=b831731e"
import script from "./ResponsePositionEditor.vue?vue&type=script&lang=js"
export * from "./ResponsePositionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports